import { Dropdown } from '@components';
import { NewBankType } from '@features/branch-management/constants';
import { BankAccount } from 'types/account-detail';
import { DropdownOption } from 'types/dropdown';

import BankAccountOption from './BankAccountOption';

type BankAccountDropdownProps = {
  accounts: (BankAccount | NewBankType)[];
  selectedAccountId?: number | string;
  onSelect: (accountId: string) => void;
};

const BankAccountDropdown = ({
  accounts,
  selectedAccountId,
  onSelect
}: BankAccountDropdownProps) => {
  const options: DropdownOption[] = accounts.map((account) => ({
    id: String(account.accountDetailId),
    value: String(account.accountDetailId),
    element: <BankAccountOption account={account} />
  }));

  return (
    <Dropdown
      filterOptions={options}
      currentFilter={selectedAccountId ? String(selectedAccountId) : ''}
      onSelectFilter={onSelect}
      placeholder="Select Bank"
      className="!h-auto !min-h-14 w-63 !justify-between !rounded-xl !border-greyStroke !bg-white !py-2"
      labelStyle="!flex !min-w-0 !flex-1 !justify-start !text-left !font-normal"
      placeholderStyle="!text-grey !font-normal"
      listId="bank-account"
      optionsStyle="!w-74 !right-0 max-h-83 overflow-y-auto [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-thumb]:bg-gray-400 [&::-webkit-scrollbar-track]:bg-gray-100"
      usePortal
    />
  );
};

export default BankAccountDropdown;
